function createLineChart(canvasId) {
  const ctx = document.getElementById(canvasId);

  // Create gradients
  const greenGradient = ctx.getContext('2d').createLinearGradient(0, 0, 0, 400);
  greenGradient.addColorStop(0, 'rgba(78, 205, 196, 0.8)');
  greenGradient.addColorStop(1, 'rgba(78, 205, 196, 0.1)');

  const blueGradient = ctx.getContext('2d').createLinearGradient(0, 0, 0, 400);
  blueGradient.addColorStop(0, 'rgba(135, 206, 235, 0.8)');
  blueGradient.addColorStop(1, 'rgba(135, 206, 235, 0.1)');

  const data = {
    labels: ['Aug 15', 'Aug 16', 'Aug 17', 'Aug 18', 'Aug 19', 'Aug 20', 'Aug 21'],
    datasets: [
      {
        label: 'Personnel',
        data: [25000, 35000, 8000, 30000, 6000, 12000, 28000],
        fill: true,
        borderColor: '#4ECDC4',
        backgroundColor: greenGradient,
        tension: 0.5,
        pointRadius: 4,
        pointHoverRadius: 8,
        borderWidth: 3
      },
      {
        label: 'Revenue',
        data: [500, 2500, 3500, 20000, 3000, 1000, 2000],
        fill: true,
        borderColor: '#87CEEB',
        backgroundColor: blueGradient,
        tension: 0.5,
        pointRadius: 4,
        pointHoverRadius: 8,
        borderWidth: 3
      }
    ]
  };

  return new Chart(ctx, {
    type: 'line',
    data: data,
    options: {
      responsive: true,
      interaction: { mode: 'index', intersect: false },
      plugins: {
        legend: { display: false },
        tooltip: {
          enabled: true,
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          titleColor: '#333',
          bodyColor: '#333',
          borderColor: '#ddd',
          borderWidth: 1
        }
      },
      scales: {
        x: { grid: { display: false }, ticks: { color: '#999' } },
        y: {
          grid: { color: 'rgba(0,0,0,0.1)' },
          ticks: {
            color: '#999',
            callback: value => value >= 1000 ? (value / 1000) + 'K' : value
          },
          max: 30000
        }
      }
    }
  });
}
export { createLineChart };

